import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Row, Col } from 'react-bootstrap';
import { createPayment } from '../../redux/slices/paymentsSlice';

const PaymentForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    title: '',
    total_amount: '',
    installments_count: '',
    payment_day: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const paymentData = {
      ...formData,
      total_amount: parseFloat(formData.total_amount),
      installments_count: parseInt(formData.installments_count),
      payment_day: parseInt(formData.payment_day),
    };

    const result = await dispatch(createPayment(paymentData));
    
    if (!result.error) {
      navigate('/payments');
    }
  };

  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card>
            <Card.Body>
              <h2 className="mb-4">Nuevo Microcrédito</h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Título</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="Ej: Préstamo Personal"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Monto Total</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="total_amount"
                    value={formData.total_amount}
                    onChange={handleChange}
                    placeholder="0.00"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Cantidad de Cuotas</Form.Label>
                  <Form.Control
                    type="number"
                    name="installments_count"
                    value={formData.installments_count}
                    onChange={handleChange}
                    placeholder="12"
                    min="1"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Día de Pago (1-28)</Form.Label>
                  <Form.Control
                    type="number"
                    name="payment_day"
                    value={formData.payment_day}
                    onChange={handleChange}
                    placeholder="15"
                    min="1"
                    max="28"
                    required
                  />
                  <Form.Text className="text-muted">
                    Día del mes en que vence cada cuota
                  </Form.Text>
                </Form.Group>

                <div className="d-flex gap-2">
                  <Button variant="primary" type="submit" className="flex-grow-1">
                    Crear Microcrédito
                  </Button>
                  <Button variant="secondary" onClick={() => navigate('/payments')}>
                    Cancelar
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentForm;
